import React, {Component} from 'react';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../../components/Skeleton/Skeleton";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import ContentAccordion from "../../../components/ContentAccordion/ContentAccordion";
import store from "../../../store";
import {Helmet} from "react-helmet";

class Packaging extends Component {
  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Ship" ? row.sections.map((section) => {
                          return section.title === "Guidelines & Tools" ? section.subsections.map((subsection) => {
                                      return subsection.title === "Packaging" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                  })
                                  : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/packaging-heading.html"
        />
        <div className="pbl">
          <ContentAccordion jsonDataUrl="./content/ship/page-components/accordion/packaging.json"/>
        </div>
      </div>
    );
  }
}

export default Packaging;



// WEBPACK FOOTER //
// ./src/pages/ship/GuidelinesAndTools/Packaging.js